<section-panel
  [borderless]="true"
  paddings="small"
>
  <div class="header">
    <span class="label">Security</span>

    <button
      *ngIf="showLockButton"
      type="button"
      class="lock-button"
      [class.lock-button-locked]="lockView === 'locked' || lockView === 'unlocking'"
      [class.lock-button-jammed]="lockView === 'jammed'"
      [disabled]="lockView === 'locking' || lockView === 'unlocking'"
      (click)="onLockButton()"
    >
      <ion-icon
        [name]="lockView === 'jammed' ? 'warning-outline' : lockView === 'locked' || lockView === 'locking' ? 'lock-closed-outline' : 'lock-open-outline'"
        aria-hidden="true"
      ></ion-icon>
      <span>{{ lockLabel }}</span>
    </button>
  </div>

  <div 
    class="slider"
    [ngClass]="{ 'slider-armed': isArmed(), 'slider-hide': showAnimation }"
  >
    <div class="slider_labels" [class]="isArmed() ? 'ltr_shine' : 'rtl_shine'">
      <span class="slider_labels-arrows" [class]="isArmed() ? '' : 'left'">&lt; &lt; &lt;</span>
      <span class="slider_labels-text">
        {{currentDisplayLabel}}
      </span>
      <span class="slider_labels-arrows" [class]="isArmed() ? 'right' : ''">&gt; &gt; &gt;</span>
    </div>

    <input 
      #slider 
      *ngIf="true"
      type="range" 
      [value]="initialValue" 
      [min]="minValue" 
      [max]="maxValue" 
      class="slider_dragger"
      [class]="isArmed() ? 'slider_dragger-armed' : ''"
    />
  </div>

  <div
    *ngIf="showAnimation"
    class="slider-blink" 
    [style]="'--animationDuration: ' + animationDuration + ';'"
    [class]="isArmed() ? 'slider-blink_lock' : 'slider-blink_unlock'"
  >
    <div class="slider-blink_labels">
      <span class="slider-blink_labels-lock" [class]="isArmed() ? '' : 'hide'"></span>
      <span class="slider-blink_labels-text">
        {{isArmed() ? ARMING_LABEL : DISARMING_LABEL}}
      </span>
      <span class="slider-blink_labels-lock" [class]="isArmed() ? 'hide' : ''"></span>
    </div>
  </div>

  <!-- Unlock, or arming over a jam: the app's shared confirm card
       (theme/_confirm-card.scss). A tap on the backdrop cancels, as on a native alert. -->
  <div class="card-overlay" *ngIf="confirm" @cardBackdrop (click)="cancelConfirm()">
    <div
      class="confirm-card"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="lock-confirm-msg"
      @cardPop
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngIf="confirm === 'unlock'; else armOverJam">
        <div class="confirm-msg" id="lock-confirm-msg">Unlock the front door?</div>
        <button type="button" class="confirm-primary" (click)="confirmUnlock()">Unlock door</button>
      </ng-container>
      <ng-template #armOverJam>
        <div class="confirm-msg" id="lock-confirm-msg">Your front door is jammed and may not be locked. Arm anyway?</div>
        <button type="button" class="confirm-primary danger" (click)="confirmArmOverJam()">Arm anyway</button>
      </ng-template>
      <button #confirmCancel type="button" class="confirm-cancel" (click)="cancelConfirm()">Cancel</button>
    </div>
  </div>
</section-panel>